import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { NzSegmentedModule } from 'ng-zorro-antd/segmented';
import { getSettingsKey } from '../../../settings/settings.pure';

@Component({
  selector: 'etoh-dashboard-home',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    NzSegmentedModule,
    FormsModule,
    RouterModule,
  ],
  template: `
    <div class="mat-h2">Dashboard</div>

    @if (!isDashboardEnabled) { Dashboard disabled. If you want to enable it,
    please go to the <a routerLink="/features/settings">settings</a> or
    <a nz-button nzType="link" (click)="isDashboardEnabled = true"
      >enable it temporary</a
    >.} @else {

    <nz-segmented
      [nzOptions]="options"
      [ngModel]="currentPage"
      (ngModelChange)="handleIndexChange($event)"
    ></nz-segmented>

    <router-outlet></router-outlet>

    }
  `,
  styleUrl: './dashboard.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardHomeComponent {
  #router = inject(Router);
  options = ['Overview', 'Metrics', 'Agreements', 'Companies', 'More'];
  currentPage = 0;

  isDashboardEnabled = !getSettingsKey('disableDashboard');

  handleIndexChange(e: number): void {
    console.log(e);
    setTimeout(() => {
      this.#router.navigateByUrl(
        `/features/dashboard/${this.options[e].toLowerCase()}`
      );
    });
  }

  ngOnInit() {
    console.log(this.#router.url.split('/').pop());
    const indexPath = this.#router.url.split('/').pop();
    this.currentPage = this.options.findIndex(
      (o) => o.toLocaleLowerCase() === indexPath
    );
  }
}
